import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["footerContent", "onCancelClick", "onConfirmClick"];
export var useOptionListFooter = function useOptionListFooter(_ref) {
  var footerContent = _ref.footerContent,
      onCancelClick = _ref.onCancelClick,
      onConfirmClick = _ref.onConfirmClick,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return {
    rootProps: restProps,
    footerContent: footerContent,
    footerCancelButtonProps: {
      onClick: onCancelClick
    },
    footerConfirmButtonProps: {
      onClick: onConfirmClick
    }
  };
};